import { createGlobalStyle, css } from 'styled-components';

const appGlobalStyles = css`
  @font-face {
    font-family: 'Effra';
    src: url('../../assets/fonts/EffraVF_Wght.ttf') format('truetype');
    font-weight: 100 900;
    font-style: normal;
  }

  * {
    box-sizing: border-box;
    font-family: ${({theme}) => theme?.fontFamily?.main};
  }

  .no-window-scrollbars::-webkit-scrollbar {
    display: none;
  }

  .no-window-scrollbars {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  // show scrollbars
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
    height: 7px;
    background-color: white;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }

  // - end show scrollbars

  html,
  body,
  #root {
    height: 100%;
  }

  html {
    font-size: 14px;
  }

  body {
    overflow-y: scroll;
    margin: 0;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1rem;
    background-color: ${({theme}) => theme?.palette?.background};
  }

  h1 {
    font-size: 36px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 18px;
  }

  h4 {
    font-size: 16px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 16px;
    padding: 0;
    font-weight: 400;
  }

  h1 {
    font-size: 36px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    font-size: 18px;
  }

  h4 {
    font-size: 16px;
  }

  .section-header {
    font-size: 16px;
    font-weight: 600;
    color: #454b49; // TODO: move to the theme?
  }

  p {
    margin: 0 0 16px;
  }

  a {
    text-decoration: none;
    color: ${({theme}) => theme?.palette?.linkColor};

    &:hover {
      color: ${({theme}) => theme?.palette?.linkHoverColor};
    }
  }
`;

export const GlobalStyle = createGlobalStyle`
  ${appGlobalStyles}
`;
